import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { datesData } from '@pages/admin/calendarios/calendarios-bloqueo/block-day.service';
import { CalendarSelectDateService } from '@components/popup-calendar/calendar-select-date.service';
import { ObservatoryService, UserService } from '@services/services.module';
import { NotificationsService } from '@services/services.module';
import { Constants } from '@app/constants/constants';
import { APP_URLS } from '@app/constants/app-urls';
import { MAIN_REPORT, ROL_TYPE } from '@app/constants/enums';

@Component({
  selector: 'app-exportacion',
  templateUrl: './exportacion.component.html',
  styleUrls: ['./exportacion.component.scss'],
  providers: [NgbModalConfig, NgbModal]
})
export class ExportacionComponent implements OnInit, AfterViewInit {
  @Input() initialDateReport: any;
  @Input() endDateReport: any;
  public APP_URLS = APP_URLS;
  public userData: any;
  public open = false;
  public openDivision = false;
  public titleButton: string;
  public personalizedModal = false;
  public openClient = false;
  public openEmployee = false;
  public openResponsibleHours = false;
  public openDesvWorkingDay = false;
  public resetDatesCalendPopUp: Subject<void> = new Subject<void>();
  public resetEndDatesCalendPopUp: Subject<void> = new Subject<void>();
  public resetDatesFocusCalendar: Subject<void> = new Subject<void>();
  public setDates:  Subject<any> = new Subject<any>();
  public setEndDates:  Subject<any> = new Subject<any>();
  public setToDate: Subject<any> = new Subject<any>();
  public setFromDate: Subject<any> = new Subject<any>();
  public resetEndDate: Subject<void> = new Subject<void>();
  public setMiniumDate: Subject<any> = new Subject<any>();
  public objectOReportsfButtonsView = Constants.objectOReportsfButtons;
  public showAdminOrDirection = false;
  public showAdminDirectionOperations = false;

  // To access to MAIN_REPORT ENUM from view
  MAIN_REPORT_VIEW = MAIN_REPORT;
  // Optimous value is 60
  MAX_RANGE_DAYS = 31;

  constructor(
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    public calendarSelectDate: CalendarSelectDateService,
    private observatory: ObservatoryService,
    private notification: NotificationsService,
    private router: Router,
    config: NgbModalConfig,
    private modalService: NgbModal,
    private _user: UserService
  ) {
    window.scrollTo(0, 0);
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.translate.get(this.activatedRoute.snapshot.data['title']).subscribe((res: string) => {
      this.titleService.setTitle(res);
    });
    this.observatory.setData('loader', false);
  }

  ngAfterViewInit(): void {
      this.userControl();
      this.userControlOperations();
  }

  userControl(): void {
    this._user.checkRolType([ROL_TYPE.admin, ROL_TYPE.direction]).then((data: any) => {
      if (data.value) {
        this.showAdminOrDirection = data.value;
      }
    });
  }

  userControlOperations(): void {
    this._user.checkRolType([ROL_TYPE.admin, ROL_TYPE.direction, ROL_TYPE.operations]).then((data: any) => {
      if (data.value) {
        this.showAdminDirectionOperations = data.value;
      }
    });
  }

  /**
   *
   * @returns Formated date with format { dateEnd: string, dateEnd: string }
   */
  formatDates(): Promise<{dateEnd: string, dateInit: string}> {
    return new Promise((resolve) => {
      const endMonth = this.endDateReport.month < 10 ? '0' + this.endDateReport.month :  '' + this.endDateReport.month;
      const endDay = this.endDateReport.day < 10 ?  '0' + this.endDateReport.day : '' + this.endDateReport.day;
      const initMonth = this.initialDateReport.month < 10 ? '0' + this.initialDateReport.month : '' + this.initialDateReport.month;
      const initDay = this.initialDateReport.day < 10 ? '0' + this.initialDateReport.day : '' + this.initialDateReport.day;

      const dateEnd = '' + this.endDateReport.year + endMonth + endDay;
      const dateInit = '' + this.initialDateReport.year + initMonth + initDay;

      const returnData = {
        'dateEnd': dateEnd,
        'dateInit': dateInit
      };
      resolve(returnData);
    });
  }

  /**
   * Set the initialDateReport value
   * @param data
   */
  receiveFromDate(data): void {
    this.initialDateReport = data;
    if (this.endDateReport) {
      this.resetEndDatesCalendPopUp.next();
    }

    const dateToSend = new Date(data.year, data.month - 1, data.day);
    this.setMiniumDate.next(dateToSend);
    this.setDates.next(data);
  }

  /**
   * Set the endDateReport value
   * @param data
   */
  receiveToDate(data): void {
    this.endDateReport = data;
    this.setEndDates.next(data);
  }

  routeTo(route): void {
    this.router.navigate([route]);
  }

  /**
   * Compare two dates
   * @returns true if initial date is lower than end date
   */
  compareDates(): boolean {
    const initialDate = new Date(this.initialDateReport.year, this.initialDateReport.month, this.initialDateReport.day);
    const endDate = new Date(this.endDateReport.year, this.endDateReport.month, this.endDateReport.day);
    if (initialDate <= endDate) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * @returns Days between end date and start date
   */
  compareDays(): number {
    const initialDate = new Date(
      this.initialDateReport.year,
      this.initialDateReport.month - 1,
      this.initialDateReport.day
    );
    const endDate = new Date(
      this.endDateReport.year,
      this.endDateReport.month - 1 ,
      this.endDateReport.day
    );

    const ms = endDate.getTime() - initialDate.getTime();
    // Add one day to adjust for the first day of inital date
    const days = Math.round(ms / (24 * 60 * 60 * 1000)) + 1;

    return days;
  }

  /**
   * Process all reports
   * @param cleanFromModal boolean to clean the modal
   * @param type string to define the type of operation
   * @param divitions array of selected divitions
   */
  mainReports(cleanFromModal?: boolean, type?: string, divitions?: any[]): void {
    if (!this.endDateReport) {
      this.endDateReport = this.initialDateReport;
    }

    if (this.compareDates()) {
      this.formatDates().then((val: datesData) => {
        console.log("TYPE: ", type);
        switch (type) {
          case MAIN_REPORT.exportAdmin:
            const days = this.compareDays();
            if (days > this.MAX_RANGE_DAYS) {
              this.notification.setError(this.translate.instant('EXPORT.GREATER_THAN_MAX_RANGE_DAYS'));
            } else {
              this.calendarSelectDate.getReport(val);
            }
            break;
          case MAIN_REPORT.exportAdminHours: // Export rate hours
            this.calendarSelectDate.getExportAdminHours(val);
            break;
          case MAIN_REPORT.exportEmployeeHours: // Export rate by employee
            this.calendarSelectDate.getExportEmployeeHours(val);
            break;
          case MAIN_REPORT.exportIncidents:
            const incidentDays = this.compareDays();
            if (incidentDays > this.MAX_RANGE_DAYS) {
              this.notification.setError(this.translate.instant('EXPORT.GREATER_THAN_MAX_RANGE_DAYS'));
            } else {
              this.calendarSelectDate.getIncidentReport(val);
            }
            break;
          case MAIN_REPORT.exportNotImputed:
            this.calendarSelectDate.getNoImputados(val);
            break;
          case MAIN_REPORT.exportInterventionHoursControl:
            this.calendarSelectDate.getInterventions(val);
            break;
          case MAIN_REPORT.exportGuards:
            this.calendarSelectDate.getGuards(val);
            break;
          case MAIN_REPORT.exportsDesvWorkingDay:
            this.calendarSelectDate.getDesvWorkingDay(val, divitions);
            break;
          case MAIN_REPORT.exportExtraHours:
            const extraHoursDays = this.compareDays();
            if (extraHoursDays > this.MAX_RANGE_DAYS) {
              this.notification.setError(this.translate.instant('EXPORT.GREATER_THAN_MAX_RANGE_DAYS'));
            } else {
              this.calendarSelectDate.getExtraHours(val);
            }
            break;
          case MAIN_REPORT.exportClient:
            this.calendarSelectDate.getHorasClientes(val, divitions);
            break;
          case MAIN_REPORT.exportEmployee:
            this.calendarSelectDate.getHorasEmpleados(val, divitions);
            break;
          case MAIN_REPORT.exportResponsibleHours:
            this.calendarSelectDate.getResponsibles(val, divitions);
            break;
          case MAIN_REPORT.exportResponsibleOpenModal:
            this.responsible(divitions);
            break;
          case MAIN_REPORT.exportOpenModalClient:
            this.openModalClient(divitions);
            break;
          case MAIN_REPORT.exportOpenModalEmployee:
            this.openModalEmployee(divitions);
            break;
          case MAIN_REPORT.exportOpenModalDesvWorkingDay:
            this.desvWorkingDay(divitions);
            break;
          case MAIN_REPORT.exportProjectFeesEmployee:
            const projectFeesEmployeeDays = this.compareDays();
            if (projectFeesEmployeeDays > this.MAX_RANGE_DAYS) {
              this.notification.setError(this.translate.instant('EXPORT.GREATER_THAN_MAX_RANGE_DAYS'));
            } else {
              this.calendarSelectDate.getProjectFeesEmployee(val);
            }
            break;
        }
      }, err => {
        console.error(err);
      });
    } else {
      this.notification.setWarning(this.translate.instant('EXPORT.FECHA_INICIAL_MAYOR_FECHA_FINAL'));
    }

    this.cancel();
    if (cleanFromModal) {
      this.initialDateReport = undefined;
      this.endDateReport = undefined;
    }
  }

  /**
   * Format initial date using the component date structure
   * @param data is initial date
   */
  getInitDate(data: Date): void {
    if (data) {
      const date = {
        year: data.getFullYear(),
        month: data.getMonth() + 1,
        day: data.getDate()
      };
      this.initialDateReport = date;
      this.setFromDate.next(this.initialDateReport);
      this.setMiniumDate.next(data);

    } else {
      this.resetEndDatesCalendPopUp.next();
      this.resetDatesFocusCalendar.next();
      this.initialDateReport = undefined;
      this.endDateReport = undefined;
    }
  }

  /**
   *  Format end date using the component date structure
   * @param data is end date
   */
  getEndDate(data: Date): void {
    if (data) {
      this.endDateReport = {
        year: data.getFullYear(),
        month: data.getMonth() + 1,
        day: data.getDate()
      };

      this.setToDate.next(this.endDateReport);
    } else {
      this.resetEndDate.next();
      this.endDateReport = undefined;
    }
  }

  openModalClient(content): void {
    this.openResponsibleHours = false;
    this.openEmployee = false;
    this.openClient = true;
    this.openDesvWorkingDay = false;
    this.modalService.open(content);
  }

  openModalEmployee(content): void {
    this.openResponsibleHours = false;
    this.openEmployee = true;
    this.openClient = false;
    this.openDesvWorkingDay = false;
    this.modalService.open(content);
  }

  responsible(content): void {
    this.openResponsibleHours = true;
    this.openEmployee = false;
    this.openClient = false;
    this.openDesvWorkingDay = false;
    this.modalService.open(content);
  }

  desvWorkingDay(content): void {
    this.openResponsibleHours = false;
    this.openEmployee = false;
    this.openClient = false;
    this.openDesvWorkingDay = true;
    this.modalService.open(content);
  }

  /**
   * Clean and close the modal
   */
  cancel(): void {
    this.openResponsibleHours = false;
    this.openDivision = false;
    this.personalizedModal = false;
    this.openClient = false;
    this.openEmployee = false;
    this.openDesvWorkingDay = false;
    this.modalService.dismissAll();
  }
}
